import { Mark, mergeAttributes } from "@tiptap/core";

/**
 * Preserves `<span class="...">...</span>` in incoming HTML and when serializing `getHTML()`.
 * Intentionally skips mention spans (`data-type="mention"`) so Mention extension keeps control.
 */
export const ClassSpanMark = Mark.create({
  name: "classSpan",

  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute("class"),
        renderHTML: (attributes) => {
          if (!attributes.class) {
            return {};
          }
          return { class: attributes.class };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[class]",
        getAttrs: (node) => {
          if (!(node instanceof HTMLElement)) {
            return false;
          }
          // Let Mention parse its own HTML (`<span data-type="mention" ...>`).
          if (node.getAttribute("data-type") === "mention") {
            return false;
          }
          return null;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes), 0];
  },
});

/**
 * Preserves `<mark class="...">...</mark>` in incoming HTML and when serializing `getHTML()`.
 */
export const ClassMark = Mark.create({
  name: "classMark",

  addAttributes() {
    return {
      class: {
        default: null,
        parseHTML: (element) => element.getAttribute("class"),
        renderHTML: (attributes) => {
          if (!attributes.class) {
            return {};
          }
          return { class: attributes.class };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: "mark" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["mark", mergeAttributes(HTMLAttributes), 0];
  },
});
